import { render, staticRenderFns } from "./TableEx.vue?vue&type=template&id=0c3f205c&scoped=true&"
import script from "./TableEx.vue?vue&type=script&lang=js&"
export * from "./TableEx.vue?vue&type=script&lang=js&"
import style0 from "./TableEx.vue?vue&type=style&index=0&id=0c3f205c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3f205c",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/common/TableEx.vue
// module id = 1593
// module chunks = 0